module.exports = __webpack_public_path__ + "img/apps.1d6c7aef.png";